import type { AuthContextValue } from "./auth.type";

import { createContext } from "react";

export const config = {
  contextName: "AuthContext",
  providerName: "AuthProvider",
};

export const AuthContext = createContext<AuthContextValue | null>(null);
